<template>
  <StakeModal v-model="show">
    <Stack gap="4">
      <Title>{{ title }}</Title>
      <p>{{ message }}</p>

      <div class="tw-flex tw-gap-3">
        <Button
          variant="danger"
          :loading="loading"
          @click="confirm"
        >
          {{ buttonText }}
        </Button>

        <Button
          variant="secondary"
          :disabled="loading"
          @click="cancel"
        >
          Cancel
        </Button>
      </div>
    </Stack>
  </StakeModal>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import { Button, Stack, Title } from '@stakeui';
import StakeModal from '@stakeui/StakeModal.vue';


const props = defineProps({
  value: Boolean,
  title: {
    type: String,
    default: 'Confirm',
  },
  message: {
    type: String,
    default: 'Are you sure?',
  },
  buttonText: {
    type: String,
    default: 'Confirm',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});


const show = ref(props.value);
const emit = defineEmits(['input', 'update:value']);


watch(() => props.value, newVal => {
  show.value = newVal;
});


watch(show, newVal => {
  emit('input', newVal);
  emit('update:value', newVal);
});


const confirm = () => {
  emit('confirm');
};


const cancel = () => {
  emit('cancel');
};

</script>
